import {Observable} from "rxjs";
import {Observer} from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {share} from "rxjs/operators";

export class TimingParameters {
    // Three sets of timing parameters for interventions: one for automated testing, one for lower reading levels
    // (allows more time before intervention) and one for higher reading levels
    // levels are based on ATOS grade equivalent
    public static visualTest:Array<number> = [100, 300, 300, 300];
    public static visualLowerReadingLevel:Array<number> = [2000, 3000, 3000, 3000];
    public static visualHigherReadingLevel:Array<number> = [1500, 2000, 2000, 3000];

    public static audioTest:Array<number> = [200, 300, 400, 500];
    public static audioLowerReadingLevel:Array<number> = [2000, 3000, 4000, 5000];
    public static audioHigherReadingLevel:Array<number> = [1500, 2000, 4000, 5000];

    private audio:number;
    private visual:number;
    private skip = 3000; // 3 seconds to skip word entirely
    private mock = 20000; // for automated testing, basically turn off interventions
    private wordWall = 3000; // 3 seconds for user to say a word wall item.
    private microphoneCheck = 5000;
    public static build(contentLevel:number, setting:number):TimingParameters {
        let parameters:TimingParameters = new TimingParameters();
        if (contentLevel < 0) {
            parameters.audio = TimingParameters.audioTest[setting];
            parameters.visual = TimingParameters.visualTest[setting];
        } else if (contentLevel < 3) {
            parameters.audio = TimingParameters.audioLowerReadingLevel[setting];
            parameters.visual = TimingParameters.visualLowerReadingLevel[setting];
        } else {
            parameters.audio = TimingParameters.audioHigherReadingLevel[setting];
            parameters.visual = TimingParameters.visualHigherReadingLevel[setting];
        }
        return parameters;
    }

    public getAudio():number {
        return this.audio;
    }

    public getVisual():number {
        return this.visual;
    }

    public getSkip():number {
        return this.skip;
    }

    public getMock():number {
        return this.mock;
    }

    public getMicrophoneCheck():number {
        return this.microphoneCheck;
    }

    public getWordWall():number {
        return this.wordWall;
    }

}

export interface InterventionState {
    name():string;
    start():number;
    stop():void;
    getNextState():InterventionState;
}

export class BaseInterventionState implements InterventionState {
    // This timing offset really has to do with deferring interventions, which is not implemented currently (TODO)
    // static TRANSITION_TIME:number = 750;
    static TRANSITION_TIME:number = 0;
    WAIT:number;
    public status:Observable<string>;
    statusObserver:Observer<string>;
    timerId:number;
    interventionMessage:string;
    nextInterventionState:InterventionState;

    constructor(private timing:TimingParameters) {
        this.status = new Observable<string>(observer => {
            this.statusObserver = observer;
        }).pipe(share());
        this.WAIT = timing.getVisual() + BaseInterventionState.TRANSITION_TIME;
        this.interventionMessage = "Timer for BaseIntervention";
    }

    public name():string {
        return "BaseIntervention";
    }

    public stop():void {
        console.log("stopping timer for " + this.name() +
                    " id " + this.timerId + " message " + this.interventionMessage);
        clearTimeout(this.timerId);
        // if (this.getNextState()) {
            // this.getNextState().stop();
        // }
    }

    public start():number {
        this.stop();
        this.timerId = window.setTimeout( () => {
            console.log(this.interventionMessage);
            this.statusObserver.next(this.interventionMessage);
        }, this.WAIT);
        return Date.now();
    }

    public setNextState(nextState:InterventionState):void {
        this.nextInterventionState = nextState;
    }

    public getNextState():InterventionState {
        return this.nextInterventionState;
    }
}

export class VisualInterventionState extends BaseInterventionState {

  constructor(timing:TimingParameters) {
      super(timing);
      this.WAIT = timing.getAudio() + BaseInterventionState.TRANSITION_TIME;
      this.interventionMessage = "Timer for VisualIntervention";
  }
}

export class AudioInterventionState extends BaseInterventionState {

    constructor(timing:TimingParameters) {
        super(timing);
        this.WAIT = timing.getSkip();
        this.interventionMessage = "Timer for AudioIntervention:";
    }
}

export class MockInterventionState extends BaseInterventionState {

    constructor(timing:TimingParameters) {
        super(timing);
        this.WAIT = timing.getMock();
        this.interventionMessage = "Timer for Mock Testing:";
    }
}

export class MicrophoneCheckInterventionState extends BaseInterventionState {

    constructor(timing:TimingParameters) {
        super(timing);
        this.WAIT = timing.getMicrophoneCheck();
        this.interventionMessage = "Timer for MicCheckIntervention:";
    }
}

export class WordWallInterventionState extends BaseInterventionState {

    constructor(timing:TimingParameters) {
        super(timing);
        this.WAIT = timing.getWordWall();
        this.interventionMessage = "Timer for WordWallIntervention:";
    }
}
